import css from 'styled-jsx/css';
import { colors } from '../../styles/theme';

const styles = theme => {
  return css.resolve`
    .button-checkin-box {
      display: flex;
      justify-content: flex-start;
      align-items: center;

      background: white;
      border-radius: 20px;

      margin-bottom: 16px;
      min-height: 70px;
      border: 1px solid ${theme.mainColor};
    }

    .button-checkin-box.active {
      cursor: pointer;
    }

    .guests-count {
      display: flex;
      align-items: center;
      justify-content: center;
      padding-right: 0px;
      padding-left: 15px;
    }

    .icon-container {
      flex: 1 0 20%;
    }

    .button-name {
      flex: 2 0 50%;
      padding: 10px 0;
      text-align: left;
      color: ${theme.mainColor};
    }

    .button-container {
      flex: 1 0 30%;
    }

    .button {
      background: ${theme.secondaryColor};
      color: white;
      font-weight: normal;
      border: none;
      padding: 10px 10px;
      border-radius: 25px;
      min-width: 80px;
      border: 1px solid ${theme.secondaryColor};
      cursor: pointer;
    }

    .button.action {
      margin: 10px;
    }

    .button.finished {
      background: ${colors.lightGreen};
      color: ${colors.green};
      border: 1px solid ${colors.green};
      cursor: default;
    }

    .button.disabled {
      border: 1px solid ${colors.grey};
      color: ${colors.grey};
    }
  `;
};
export default styles;
